'use es6';

import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
const NoSurvey = () => /*#__PURE__*/_jsx(NavMarker, {
  name: "no_survey"
});
export default NoSurvey;